import state from './state';
import Store from '../../base/index';


export default class SmsTemplates extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}



// WEBPACK FOOTER //
// ./src/app/store/messages/sms-templates/index.js